import React from "react";

export const Loading = () => {
    return (
        <div className="card placeholder-glow">
            <div className="card-body rounded-2 placeholder" style={{height: "60px"}}/>
        </div>
    );
}

export default Loading;
